
import { DossierConfigService } from "@/services/dossier-config-service";
import { DocumentLayoutClientHeading } from "@/utils/documents/layout-client-heading";
import { DocumentPageSettings } from "@/utils/documents/page-settings";
import { StringStyledPropertyWithFreeLine } from "@/utils/documents/string-styled-property-with-free-line";
import AppDraggableResizeCombo from "./DraggableResizeCombo.vue";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	props: {
		heading: Object as () => DocumentLayoutClientHeading,
		pageSettings: Object as () => DocumentPageSettings,
		headingHeight: Number,
		lang: String,
		contactGroupId: Number
	},
	computed: {
		props(): string[] {
			let items = [] as string[];
			for (let i = 0; i < 9; i++) {
				items.push("Property" + (i + 1));
			}
			return items;
		},
	},
	methods: {
		getText(headingNum:string):TranslateResult | string {
			let text = ((this.heading as any)[headingNum] as StringStyledPropertyWithFreeLine).Value;
			if (this.contactGroupId && text.startsWith("ExtraField")) {
				let conf = DossierConfigService.getExtraFieldNamesConfigs().getContactNamesByGroupID(this.contactGroupId);
				let result = text.substring("ExtraField".length);
				result = (conf as any)[result] as string;
				if (result) return result;
			}
			return this.$t("models.map.ContactAddress."+text);
		}
	},
	components: {
		AppDraggableResizeCombo,
	}
});
